/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = External
 *
 * 1 = SalesPreparation
 */
export enum WipAccountTypeEnum {
  External = 0,
  SalesPreparation = 1,
}
